export default __webpack_public_path__ + "static/weizmann-6c26299fed179aea16ef73aa62948c45.png";